import styled from 'styled-components';
import { Chip } from '@material-ui/core';
import Input from '../../../components/Forms/Input';

export const Wrap = styled.div``;

export const InputKey = styled(Input)``;

export const TagList = styled.div`
  margin-top: 20px;
`;

export const Tag = styled(Chip)`
  margin-right: 10px;
`;
